import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { useSEO } from "../lib/seo";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { EstimateForm } from "../components/EstimateForm";
import { BUSINESS } from "../lib/constants";

const ContactPage = () => {
  useSEO(
    "Contact Us | Kay's Carpet Cleaning Gold Coast",
    "Talk to Kay's Carpet Cleaning about your cleaning job. Call 0450 311 907 or email info@kayscarpetcleaning.com.au. Gold Coast wide, Monday to Saturday 8 AM – 8 PM."
  );

  return (
    <div data-testid="contact-page">
      <PageHero
        overline="Contact"
        title="Talk to"
        titleItalic="Kay's Carpet Cleaning"
        text="Call, email or send through the form below — tell us what you need cleaned and we'll provide an estimate based on your requirements."
        testId="contact-hero"
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-20 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 space-y-4">
          <Reveal>
            <a href={BUSINESS.phoneHref} data-testid="contact-page-phone" className="group flex items-center gap-5 bg-brand rounded-2xl p-6 transition-transform duration-300 hover:scale-[0.98]">
              <span className="inline-flex w-12 h-12 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white"><Phone size={22} /></span>
              <span>
                <span className="block text-xs font-bold uppercase tracking-[0.12em] text-white/70">Call us — fastest response</span>
                <span className="block mt-1 font-display font-semibold text-xl text-white">{BUSINESS.phoneDisplay}</span>
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.06}>
            <a href={BUSINESS.emailHref} data-testid="contact-page-email" className="group flex items-center gap-5 bg-white border border-brand-line/60 rounded-2xl p-6 transition-[border-color] duration-300 hover:border-brand">
              <span className="inline-flex w-12 h-12 shrink-0 items-center justify-center rounded-xl bg-brand-mist text-brand"><Mail size={22} /></span>
              <span className="min-w-0">
                <span className="block text-xs font-bold uppercase tracking-[0.12em] text-brand-muted">Email us</span>
                <span className="block mt-1 font-display font-semibold text-base text-brand-ink break-all">{BUSINESS.email}</span>
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-5 bg-white border border-brand-line/60 rounded-2xl p-6" data-testid="contact-page-area">
              <span className="inline-flex w-12 h-12 shrink-0 items-center justify-center rounded-xl bg-brand-mist text-brand"><MapPin size={22} /></span>
              <span>
                <span className="block text-xs font-bold uppercase tracking-[0.12em] text-brand-muted">Service area</span>
                <span className="block mt-1 font-display font-semibold text-base text-brand-ink">Gold Coast, Queensland & surrounds</span>
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.14}>
            <div className="flex items-center gap-5 bg-white border border-brand-line/60 rounded-2xl p-6" data-testid="contact-page-hours">
              <span className="inline-flex w-12 h-12 shrink-0 items-center justify-center rounded-xl bg-brand-mist text-brand"><Clock size={22} /></span>
              <span>
                <span className="block text-xs font-bold uppercase tracking-[0.12em] text-brand-muted">Opening hours</span>
                <span className="block mt-1 font-display font-semibold text-base text-brand-ink">Monday – Saturday, 8:00 AM – 8:00 PM</span>
              </span>
            </div>
          </Reveal>
        </div>

        <Reveal className="lg:col-span-7" delay={0.1}>
          <EstimateForm compact />
        </Reveal>
      </div>
    </div>
  );
};

export default ContactPage;
